<div class="alert success" role="status" data-tfa="snack-success" animate.enter="snackbar-enter" animate.leave="snackbar-leave">
  <div class="type-icon">
    <mat-icon data-tfa="check_circle" aria-hidden="true">check_circle_outline</mat-icon>
  </div>

  <span class="message">{{data['message']}}</span>

  <button mat-button class="close" data-dismiss="alert" data-tfa="Close" (click)="snackBarRef.dismiss()" aria-label="fermer">
    <mat-icon data-tfa="cancel">close</mat-icon>
  </button>
</div>
